import { firebaseApp } from "../config/Firebase";

const Methods = {
  HEAD: "HEAD",
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  PATCH: "PATCH",
  DELETE: "DELETE"
};

export default class FirebaseConnector {
  constructor(options = {}) {
    const { apikey = "", timeout = 0, trackingId = "" } = options;
    this._defaultHeaders = {};
    if (apikey) this._defaultHeaders["X-ApiKey"] = apikey;
    if (trackingId) this._defaultHeaders["X-TrackingId"] = trackingId;
    if (timeout) this._timeout = timeout;
    this.token
    // this.onChangeToken()
    
  }

  onChangeAuth(callback){
    return firebaseApp.auth().onAuthStateChanged(callback)
  }

  // onChangeToken(){
  //   firebaseApp.auth().onIdTokenChanged(async (user)=>{
  //     console.log("ON CHANGE TOKEN", user)
  //     if(user){
  //       const token = await user.getIdToken(true)
  //       this.token=token
  //     }else{
  //       this.token = null
  //     }
  //   })
  // }

  login(user, pass) {
    return new Promise(async (resolve, reject) => {
      try {
        let auth = firebaseApp.auth();
        let resp = auth.signInWithEmailAndPassword(user, pass);
        resolve(resp);
      } catch (error) {
        reject(error);
      }
    });
  }

  logout(){
    return firebaseApp.auth().signOut()
  }

  getToken() {
    return firebaseApp.auth().currentUser.getIdToken(true)
    // return new Promise(async (resolve, reject) => {
    //   try {
    //     if(!this.token){
    //       console.log("BUSCO EN EL CURRENT USER EL TOKEN")
    //       if(firebaseApp.auth().currentUser){
    //         this.token = await firebaseApp.auth().currentUser.getIdToken(true);  
    //       }
    //     }
    //     console.log("GET TOKEN", this.token)
    //     resolve(this.token)
    //   } catch (error) {
    //     console.log("ERROR GET TOKEN", error)
    //     reject(error);
    //   }
    // });
  }

  // init(config) {
  //   firebaseApp.initializeApp(config);
  // }

  // get(uri, id, callback) {
  //   return new Promise((resolve, reject) => {
  //     if (id) {
  //       uri = uri + "/" + id;
  //     }
  //     db.ref(uri).once("value", snapshot => {
  //       let snap = snapshot.val();
  //       resolve(snap);
  //       if (callback) {
  //         callback(snap);
  //       }
  //     });
  //   });
  // }

  // del(uri, id) {
  //   db.ref(uri + "/" + id).remove();
  // }

  // save(uri, obj, id) {
  //   let newKey = id ? id : new Date();
  //   db.ref(uri + "/" + newKey.valueOf()).set(obj);
  // }

  // update(uri, obj) {
  //   db.ref(uri + "/" + obj.ref).update(obj);
  // }

  // listener(uri, callback) {
  //   db.ref(uri).on("value", snapshot => {
  //     let snap = snapshot.val();
  //     if (callback) {
  //       callback(snap);
  //     }
  //   });
  // }

  uploadFile(file, path, type, callback) {
    let storageRef = firebaseApp.storage().ref();
    let filename = new Date().getTime(); //Ver si usamos este tiempo para no pisar archivos o vamos a permitir que se pisen archivos con el mismo nombre
    filename+=`_${file.name}`
    let metadata = {
      contentType: file.type
    };
    var uploadTask = "";
    switch (type) {
      case "image":
        uploadTask = storageRef
          .child(`${path}/${filename}`)
          .put(file, metadata);
        break;
      case "excel":
        uploadTask = storageRef.child(`${path}/${filename}`).put(file);
        break;
      default:
        break;
    }
    // Register three observers:
    // 1. 'state_changed' observer, called any time the state changes
    // 2. Error observer, called on failure
    // 3. Completion observer, called on successful completion
    uploadTask.on(
      "state_changed",
      function(snapshot) {
        // Observe state change events such as progress, pause, and resume
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        var progreso = snapshot.bytesTransferred / snapshot.totalBytes * 100;
        console.log("PROGRESO", progreso, " %", snapshot.state)
        switch (snapshot.state) {
          case 'paused':
            console.log("Upload is paused");
            break;
          case 'running':
            console.log("Upload is running");
            break;
        }
      },
      function(error) {
        // Handle unsuccessful uploads
        console.log("Has been occurred an error.");
      },
      function() {
        // Handle successful uploads on complete
        // For instance, get the download URL: https://firebasestorage.googleapis.com/...
        var downloadURL = uploadTask.snapshot.downloadURL;
        callback(downloadURL, `${path}/${filename}`, file.name);
        //return downloadURL;
      }
    );
  }

  deleteFile(path, callback) {
    var storageRef = firebaseApp.storage().ref();
    let deleteRef = storageRef.child(path);
    // Delete the file
    deleteRef
      .delete()
      .then(function() {
        // File deleted successfully
        callback(true);
      })
      .catch(function(error) {
        // Uh-oh, an error occurred!
        callback(false);
      });
  }

  createUserWithEmailAndPass(user, onSuccess, onError) {
    firebaseApp
      .auth()
      .createUserWithEmailAndPassword(user.userName, user.password)
      .then(user => {
        if (onSuccess) onSuccess(user);
      })
      .catch(error => {
        if (onError) onError(error);
      });
  }

  forgotPassword(email) {
    return new Promise(async (resolve, reject) => {
      try {
        let auth = firebaseApp.auth();
        let resp = auth.sendPasswordResetEmail(email, null);
        resolve(resp);
      } catch (error) {
        reject(error);
      }
    });
  }

  confirmPasswordReset(code, password) {
    return new Promise(async (resolve, reject) => {
      try {
        let auth = firebaseApp.auth();
        let resp = auth.confirmPasswordReset(code, password);
        resolve(resp);
      } catch (error) {
        reject(error);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/provider/lib/FirebaseConnector.js